// Generated by Melange

import * as ApmRum from "@elastic/apm-rum";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";

function getConfig(param) {
  return Belt__Belt_Option.getWithDefault(Caml_option.undefined_to_opt(typeof __APM__ === "undefined" ? undefined : __APM__), {
    serviceName: "front-default",
    serviceVersion: "0.6.x",
    serverUrl: "",
    serverUrlPrefix: "/apm",
    environment: "test",
    distributedTracingOrigins: /* [] */ 0
  });
}

function init(param) {
  return ApmRum.init(getConfig(undefined));
}

export {
  getConfig,
  init,
}
/* @elastic/apm-rum Not a pure module */
